import classNames from 'classnames';
import React, { useCallback, useRef, useState } from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { useOnClickOutside } from 'usehooks-ts';

import { SvgIconUrl } from 'common/components';

import { useBowser } from 'common/hooks';
import svgIcons, { SvgProps } from 'common/svgIcons';

import TradeNavigationContainer from 'views/trade/Trade.navigation.container';

import './index.css';

export const QuickNavigation: React.FC<
  React.PropsWithChildren<{
    storageKeyForSearch?: string;
    chevronClassName?: string;
    onChevronClick?: () => void;
    chevronIcon?: SvgProps;
  }>
> = React.memo(
  ({
    storageKeyForSearch,
    children,
    chevronClassName = '',
    onChevronClick: onChevronClickProps,
    chevronIcon = svgIcons.ChevronDownThin(),
  }) => {
    const { isMobile } = useBowser();

    const containerRef = useRef(null);

    const [visible, toggleVisibility] = useState(false);

    const onChevronClick = useCallback(() => {
      toggleVisibility(!visible);
      onChevronClickProps?.();
    }, [onChevronClickProps, visible]);
    const onOutsideClick = useCallback(() => (visible ? toggleVisibility(false) : null), [visible]);

    useOnClickOutside(containerRef, onOutsideClick);

    const chevronActionButtonClassNames = classNames({
      'dashboards-card__dropdown': true,
      'dashboards-card__dropdown--opened': visible,
    });

    const chevronActionButton = (
      <div onClick={onChevronClick} className={chevronClassName}>
        {children}
        <SvgIconUrl className={chevronActionButtonClassNames} symbol={chevronIcon} data-test='quick-nav-chevron' />
      </div>
    );

    if (isMobile)
      return (
        <>
          {chevronActionButton}
          <BottomSheet
            expandOnContentDrag
            className='light quick-nav-list'
            open={visible}
            onDismiss={onChevronClick}
            snapPoints={({ maxHeight }) => [maxHeight * 0.9]}
            defaultSnap={({ snapPoints }) => Math.max(...snapPoints)}
          >
            <div className='quick-nav-list__container quick-nav-list__container--mob' data-test='quick-nav-container'>
              <TradeNavigationContainer storageKeyForSearch={storageKeyForSearch} />
            </div>
          </BottomSheet>
        </>
      );

    return (
      <div ref={!isMobile ? containerRef : null}>
        {chevronActionButton}
        {visible && (
          <div className='quick-nav-list__container quick-nav-list__container--desk'>
            <TradeNavigationContainer storageKeyForSearch={storageKeyForSearch} />
          </div>
        )}
      </div>
    );
  },
);

export default QuickNavigation;
